module.exports = __webpack_public_path__ + "static/media/43.613a84e5.png";